// Fan avatar client-side downscale (photos phase): the cropper hands back a
// full-resolution square PNG data URL; we shrink it to 512px and encode
// WebP (JPEG on browsers that can't encode WebP — Safari) so the upload is
// ~40KB instead of megabytes on venue WiFi. The server re-encodes again
// (sharp) regardless, so this is purely a bandwidth courtesy.

const AVATAR_SIZE = 512;

const encode = (canvas: HTMLCanvasElement, type: string, quality: number) =>
  new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, type, quality));

export async function dataUrlToAvatarBlob(dataUrl: string): Promise<Blob> {
  const img = new Image();
  img.src = dataUrl;
  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("decode failed"));
  });

  const canvas = document.createElement("canvas");
  canvas.width = AVATAR_SIZE;
  canvas.height = AVATAR_SIZE;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("canvas unavailable");
  // The crop is already square (aspect 1) — just scale it down.
  ctx.drawImage(img, 0, 0, AVATAR_SIZE, AVATAR_SIZE);

  const webp = await encode(canvas, "image/webp", 0.85);
  // Browsers that can't encode WebP silently hand back PNG — check the type.
  if (webp && webp.type === "image/webp") return webp;
  const jpeg = await encode(canvas, "image/jpeg", 0.87);
  if (jpeg) return jpeg;
  throw new Error("encode failed");
}
